(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-v2"] && !Shopify.designMode) return;
  try {
    
  // Built-in branded separator icons (used when no icons are uploaded in the
  // theme editor). Rendered via CSS mask, so they always match the text color.
  const SSM_DEFAULT_ICONS = [
    "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 32'><path fill='black' fill-rule='evenodd' d='M2 14 Q14 2 26 8 Q32 11 38 8 Q50 2 62 14 Q50 30 32 30 Q14 30 2 14 Z M6 14 Q18 16 32 16 Q46 16 58 14 Q46 12 38 12 Q32 13 26 12 Q18 12 6 14 Z'/></svg>",
    "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 40'><path fill='black' fill-rule='evenodd' d='M14 8 a12 12 0 1 0 0 24 a12 12 0 1 0 0-24 Z m0 6 a6 6 0 1 1 0 12 a6 6 0 1 1 0-12 Z'/><path fill='black' fill-rule='evenodd' d='M50 8 a12 12 0 1 0 0 24 a12 12 0 1 0 0-24 Z m0 6 a6 6 0 1 1 0 12 a6 6 0 1 1 0-12 Z'/><circle cx='29' cy='20' r='3' fill='black'/><circle cx='35' cy='20' r='3' fill='black'/></svg>",
    "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 44'><path fill='black' d='M24 42 C8 30 2 22 2 13 C2 6 7 2 13 2 C18 2 22 5 24 9 C26 5 30 2 35 2 C41 2 46 6 46 13 C46 22 40 30 24 42 Z'/></svg>",
    "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 56'><path fill='black' d='M9 24 L9 11 Q9 5 14 2.5 L17 2.5 L23 11 L23 24 Z'/><rect x='6' y='26' width='20' height='10' rx='1.5' fill='black'/><rect x='3' y='38' width='26' height='16' rx='2' fill='black'/></svg>",
    "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 56'><path fill='black' d='M20 2 L4 30 L13 30 L9 54 L29 22 L17 22 L26 2 Z'/></svg>",
    "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 56'><path d='M13 36 Q16 18 29 6 M33 40 Q28 18 29 6' stroke='black' stroke-width='3.5' fill='none' stroke-linecap='round'/><path fill='black' d='M29 6 Q36 1 43 4 Q38 11 29 6 Z'/><circle cx='12' cy='44' r='10' fill='black'/><circle cx='34' cy='47' r='9' fill='black'/></svg>"
  ];

  class AnnouncementBarV2 extends HTMLElement {
    connectedCallback() {
      const cfgEl = this.querySelector('[data-ssm-config]');
      this.config = cfgEl ? JSON.parse(cfgEl.textContent) : {};
      this.viewport = this.querySelector('.ssm-bar__viewport');
      this.msgs = Array.from(this.querySelectorAll('.ssm-bar__msg'));
      // Capture raw text now — token replacement rewrites the DOM later
      this.msgs.forEach((m) => { m.__ssmRaw = (m.textContent || '').trim().replace(/\s+/g, ' '); });
      this.dots = Array.from(this.querySelectorAll('.ssm-bar__dot'));
      this.index = 0;
      this.timers = [];
      this.storageKey = 'ssmBarDismissed:' + this.dataset.sectionId;

      this.setAttribute('data-ssm-version', '3.1');
      if (this.isDismissed()) {
        this.style.display = 'none';
        return;
      }
      this.classList.remove('ssm-bar--pending');

      // Build a category-balanced rotation order: round-robin one category per
      // beat so no category ever plays twice in a row and the dominant one
      // (e.g. curbside) can't hog the rotation. Runs even when shuffle is off
      // (shuffle only adds randomness), so DOM-grouped messages never cluster.
      this.rotationSeq = this.buildRotationSeq();

      // Left badge: parse the pool and pick one that won't echo the centered message
      this.badgeEl = this.querySelector('.ssm-bar__badge');
      this.badgePool = this.parseBadgePool();
      this.pickBadge();
      if (this.badgeEl && this.badgePool.length) {
        this.timers.push(setInterval(() => this.renderBadge(), 1000));
      }

      const close = this.querySelector('.ssm-bar__close');
      if (close) close.addEventListener('click', () => this.dismiss());

      // Style shuffle: pick a random bar style on every page view
      // (skipped in the theme editor so settings stay predictable)
      let mode = this.config.mode || 'slide';
      if (this.config.styleShuffle && !this.config.designMode) {
        const pool = (this.config.stylePool || []).filter(Boolean);
        if (pool.length) {
          mode = this.applyStyle(pool[Math.floor(Math.random() * pool.length)]);
        }
      } else if (mode === 'triple' || mode === 'shimmer') {
        mode = this.applyStyle(mode);
      }

      // Reduced motion: downgrade any animation to a slow fade
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches && mode !== 'static') {
        mode = 'fade';
        this.config.speed = Math.max(this.config.speed || 4, 7);
        this.className = this.className.replace(/ssm-bar--(slide|flip|typewriter|marquee)/, 'ssm-bar--fade');
      }
      if (this.msgs.length < 2 && (mode === 'fade' || mode === 'slide' || mode === 'flip')) {
        mode = 'static';
        this.className = this.className.replace(/ssm-bar--(fade|slide|flip)/, 'ssm-bar--static');
      }
      this.mode = mode;

      this.initCountdown();
      this.replaceStars();

      if (mode === 'marquee') this.initMarquee();
      else if (mode === 'typewriter') this.initTypewriter();
      else if (mode === 'static') this.setActive(this.rotationSeq[0]);
      else this.initRotation();

      if (this.config.pauseOnHover) {
        this.addEventListener('mouseenter', () => { this.setAttribute('data-paused', ''); });
        this.addEventListener('mouseleave', () => { this.removeAttribute('data-paused'); });
      }
    }

    disconnectedCallback() {
      this.timers.forEach((t) => clearInterval(t));
    }

    /* ---------- style shuffle: swap the whole bar style per page view ---------- */
    applyStyle(style) {
      let real = style;
      if (style === 'shimmer') real = 'static';
      if (style === 'triple') real = 'flip';
      this.className = this.className.replace(/ssm-bar--(static|fade|slide|flip|typewriter|marquee|triple|shimmer)/, 'ssm-bar--' + real);
      if (style === 'triple') {
        this.classList.add('ssm-bar--triple');
        this.buildChip();
      }
      if (style === 'shimmer') {
        this.classList.add('ssm-bar--invert');
        // Swap colors at the inline level (inline custom props beat class rules)
        const cs = getComputedStyle(this);
        const bg = (cs.getPropertyValue('--ssm-bg') || '#000').trim() || '#000';
        const text = (cs.getPropertyValue('--ssm-text') || '#fff').trim() || '#fff';
        this.style.setProperty('--ssm-bg', text);
        this.style.setProperty('--ssm-text', bg);
        this.style.setProperty('--ssm-accent', bg);
        const sheen = document.createElement('span');
        sheen.className = 'ssm-bar__sheen';
        sheen.setAttribute('aria-hidden', 'true');
        this.appendChild(sheen);
      }
      return real;
    }

    /* ---------- triple zone: live context chip that matches the message ---------- */
    buildChip() {
      const inner = this.querySelector('.ssm-bar__inner');
      if (!inner) return;
      const chip = document.createElement('div');
      chip.className = 'ssm-bar__chip';
      chip.setAttribute('aria-hidden', 'true');
      this.chipLabel = document.createElement('span');
      this.chipLabel.className = 'ssm-bar__chip-label';
      this.chipTime = document.createElement('span');
      this.chipTime.className = 'ssm-bar__chip-time';
      chip.appendChild(this.chipLabel);
      chip.appendChild(this.chipTime);
      inner.appendChild(chip);
      this.chip = chip;
      this.updateChip();
      this.timers.push(setInterval(() => this.updateChip(), 1000));
    }

    updateChip() {
      if (!this.chip) return;
      const active = this.msgs[this.index] || this.msgs[0];
      const cat = active ? (active.dataset.category || 'brand') : 'brand';
      let label, time;
      if (cat === 'pickup') { label = 'ORDER NOW \u00B7 CURBSIDE PICKUP BY'; time = this.readyByString(); }
      else if (cat === 'scheduled') { label = 'PLAN AHEAD \u00B7 SCHEDULE FOR'; time = 'ANY TIME'; }
      else if (cat === 'hours') { label = "WE'RE OPEN \u00B7 MIAMI TIME"; time = this.timeString(0); }
      else { label = 'ORDER NOW \u00B7 AT YOUR DOOR BY'; time = this.deliveredByString(); }
      this.chipLabel.textContent = label;
      this.chipTime.textContent = time;
    }

    /* ---------- left badge: shuffles, stays dynamic, and never echoes the
       category currently shown in the center message / right chip ---------- */
    parseBadgePool() {
      const raw = (this.config.badgePool || []).filter((s) => s && s.trim());
      let entries = raw.map((s) => {
        const m = s.match(/^\s*\[(\w+)\]\s*(.*)$/);
        return m ? { category: m[1].toLowerCase(), text: m[2].trim() }
                 : { category: 'brand', text: s.trim() };
      });
      if (!entries.length && this.config.leftBadge && this.config.leftBadge.trim()) {
        entries = [{ category: 'brand', text: this.config.leftBadge.trim() }];
      }
      return entries;
    }

    pickBadge() {
      if (!this.badgeEl || !this.badgePool || !this.badgePool.length) return;
      const centerCat = (this.msgs[this.index] && this.msgs[this.index].dataset.category) || 'brand';
      const avoid = new Set([centerCat]);
      if (this.chip) avoid.add(this.chipCategory(centerCat)); // also dodge the right chip's flavor
      let pool = this.badgePool.filter((b) => !avoid.has(b.category));
      if (!pool.length) pool = this.badgePool;                 // every badge collides: show anyway
      if (pool.length > 1 && this.currentBadge) {              // avoid repeating the same line
        const diff = pool.filter((b) => b.text !== this.currentBadge.text);
        if (diff.length) pool = diff;
      }
      this.currentBadge = pool[Math.floor(Math.random() * pool.length)];
      this.renderBadge();
    }

    // the category the right chip is effectively expressing (brand + delivery
    // both show the door-time chip, so they map to 'delivery')
    chipCategory(centerCat) {
      if (centerCat === 'pickup') return 'pickup';
      if (centerCat === 'scheduled') return 'scheduled';
      if (centerCat === 'hours') return 'hours';
      return 'delivery';
    }

    renderBadge() {
      if (this.badgeEl && this.currentBadge) {
        this.badgeEl.textContent = this.liveText(this.currentBadge.text);
      }
    }

    /* ---------- category-balanced rotation sequence ----------
       Returns an array of indices into this.msgs. Round-robins one category per
       beat (rotating the category order each pass so seams don't repeat) and
       advances through each category's own messages over successive passes, so
       the dominant category appears exactly once per cycle and shows a
       different line each time. A final de-cluster pass guarantees no two
       adjacent beats share a category whenever that's mathematically possible. */
    shuffleArr(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const t = a[i]; a[i] = a[j]; a[j] = t;
      }
      return a;
    }

    buildRotationSeq() {
      const n = this.msgs.length;
      if (n <= 1) return [0];
      const rnd = this.config.shuffle && !this.config.designMode;
      const catOfIdx = (i) => this.msgs[i].dataset.category || 'brand';
      const byCat = new Map();
      this.msgs.forEach((m, i) => {
        const c = m.dataset.category || 'brand';
        if (!byCat.has(c)) byCat.set(c, []);
        byCat.get(c).push(i);
      });
      let cats = Array.from(byCat.values());
      if (rnd) { cats.forEach((g) => this.shuffleArr(g)); this.shuffleArr(cats); }
      const numCats = cats.length;
      const ptr = cats.map(() => 0);
      const maxLen = cats.reduce((mx, g) => Math.max(mx, g.length), 0);
      const seq = [];
      for (let pass = 0; pass < maxLen; pass++) {
        for (let k = 0; k < numCats; k++) {
          const ci = (k + pass) % numCats;        // rotate cat order each pass
          const g = cats[ci];
          seq.push(g[ptr[ci] % g.length]);
          ptr[ci]++;
        }
      }
      // De-cluster: swap any beat that matches its predecessor's category with
      // the next later beat of a different category (no-op when unavoidable).
      for (let i = 1; i < seq.length; i++) {
        if (catOfIdx(seq[i]) === catOfIdx(seq[i - 1])) {
          for (let j = i + 1; j < seq.length; j++) {
            if (catOfIdx(seq[j]) !== catOfIdx(seq[i - 1]) &&
                (j + 1 >= seq.length || catOfIdx(seq[j + 1]) !== catOfIdx(seq[i]))) {
              const t = seq[i]; seq[i] = seq[j]; seq[j] = t; break;
            }
          }
        }
      }
      // Fix the loop seam so the last beat and the first don't share a category.
      if (seq.length > 2 && catOfIdx(seq[seq.length - 1]) === catOfIdx(seq[0])) {
        const last = seq.pop();
        let placed = false;
        for (let i = 1; i < seq.length; i++) {
          if (catOfIdx(seq[i]) !== catOfIdx(last) && catOfIdx(seq[i - 1]) !== catOfIdx(last)) {
            seq.splice(i, 0, last); placed = true; break;
          }
        }
        if (!placed) seq.push(last);
      }
      return seq;
    }

    /* ---------- smart shuffle: random within category, then interleaved
       so two messages of the same category never run back-to-back ---------- */
    interleaveByCategory(msgs) {
      const byCat = {};
      msgs.forEach((m) => {
        const c = m.dataset.category || 'brand';
        (byCat[c] = byCat[c] || []).push(m);
      });
      const groups = Object.keys(byCat).map((k) => byCat[k]);
      groups.forEach((g) => {
        for (let i = g.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          const tmp = g[i]; g[i] = g[j]; g[j] = tmp;
        }
      });
      const order = [];
      let lastCat = null;
      const total = msgs.length;
      while (order.length < total) {
        groups.sort((a, b) => b.length - a.length);
        let pick = null;
        for (const g of groups) {
          if (g.length && (g[0].dataset.category || 'brand') !== lastCat) { pick = g; break; }
        }
        if (!pick) pick = groups.find((g) => g.length);
        const m = pick.shift();
        order.push(m);
        lastCat = m.dataset.category || 'brand';
      }
      // Fix the wrap-around seam (matters for the looping marquee): if first
      // and last share a category, tuck the last item into a valid middle slot.
      const cat = (m) => m.dataset.category || 'brand';
      const n = order.length;
      if (n > 2 && cat(order[0]) === cat(order[n - 1])) {
        const lastM = order[n - 1];
        for (let i = 1; i < n - 1; i++) {
          if (cat(order[i]) !== cat(lastM) && cat(order[i - 1]) !== cat(lastM)) {
            order.pop();
            order.splice(i, 0, lastM);
            break;
          }
        }
      }
      return order;
    }

    shuffleMessages() {
      this.msgs = this.interleaveByCategory(this.msgs);
      const typed = this.viewport.querySelector('.ssm-bar__typed');
      const caret = this.viewport.querySelector('.ssm-bar__caret');
      this.msgs.forEach((m, i) => {
        this.viewport.appendChild(m);
        m.classList.toggle('is-active', i === 0);
      });
      if (typed) this.viewport.appendChild(typed);
      if (caret) this.viewport.appendChild(caret);
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === 0));
      this.index = 0;
    }

    /* ---------- separator icons: uploaded ones win, built-ins otherwise ---------- */
    getIcons() {
      const uploaded = (this.config.separatorIcons || []).filter(Boolean);
      return uploaded.length ? uploaded : SSM_DEFAULT_ICONS;
    }

    /* ---------- branded stars: any ★ typed in a message becomes one of the
       uploaded separator icons, picked at random on every page load ---------- */
    replaceStars() {
      const icons = this.getIcons();
      if (!icons.length) return;
      const pick = icons[Math.floor(Math.random() * icons.length)];
      this.querySelectorAll('.ssm-bar__msg-text').forEach((el) => {
        if (el.innerHTML.indexOf('★') !== -1) {
          el.innerHTML = el.innerHTML.split('★').join('<span class="ssm-bar__inline-icon" style="--icon:url(&quot;' + pick + '&quot;)"></span>');
        }
      });
    }

    /* ---------- rotation (fade / slide / flip) ---------- */
    initRotation() {
      const ms = (this.config.speed || 4.5) * 1000;
      this.seqPos = 0;
      this.setActive(this.rotationSeq[0]);
      this.timers.push(setInterval(() => {
        if (this.hasAttribute('data-paused')) return;
        this.seqPos = (this.seqPos + 1) % this.rotationSeq.length;
        this.setActive(this.rotationSeq[this.seqPos]);
      }, ms));
    }

    setActive(i) {
      this.index = i;
      this.msgs.forEach((m, j) => m.classList.toggle('is-active', j === i));
      this.dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
      // retrigger CSS animation
      const active = this.msgs[i];
      if (active) { active.style.animation = 'none'; void active.offsetWidth; active.style.animation = ''; }
      this.updateChip();
      this.pickBadge();
    }

    /* ---------- marquee ---------- */
    initMarquee() {
      const track = document.createElement('div');
      track.className = 'ssm-bar__track';
      const sep = this.config.separator || '\u2605';
      const icons = this.getIcons();
      let sepCount = 0;
      const half = document.createElement('div');
      half.style.cssText = 'display:flex;align-items:center;width:max-content;';
      // The marquee shows every message at once, so ALWAYS interleave
      // categories — even when message shuffle is turned off — to avoid
      // e.g. three curbside messages scrolling past back-to-back.
      const order = this.interleaveByCategory(this.msgs);
      order.forEach((m) => {
        const item = document.createElement('div');
        item.className = 'ssm-bar__track-item';
        item.innerHTML = m.innerHTML;
        half.appendChild(item);
        if (icons.length) {
          const ic = document.createElement('span');
          ic.className = 'ssm-bar__track-icon';
          ic.style.setProperty('--icon', 'url("' + icons[sepCount % icons.length] + '")');
          half.appendChild(ic);
          sepCount++;
        } else {
          const s = document.createElement('span');
          s.className = 'ssm-bar__track-sep';
          s.textContent = sep;
          half.appendChild(s);
        }
      });
      track.appendChild(half);
      track.appendChild(half.cloneNode(true)); // second copy => seamless -50% loop
      this.viewport.appendChild(track);

      // duration from real width so px/s speed is honored
      requestAnimationFrame(() => {
        const pxPerSec = this.config.marqueeSpeed || 60;
        const halfWidth = half.scrollWidth || 600;
        track.style.setProperty('--ssm-marquee-duration', (halfWidth / pxPerSec).toFixed(2) + 's');
        this.style.setProperty('--ssm-marquee-duration', (halfWidth / pxPerSec).toFixed(2) + 's');
      });
    }

    /* ---------- typewriter ---------- */
    initTypewriter() {
      const typed = this.querySelector('.ssm-bar__typed');
      const texts = this.msgs.map((m) => m.__ssmRaw || (m.textContent || '').trim().replace(/\s+/g, ' '));
      const type = this.config.typeSpeed || 50;
      const del = Math.max(12, Math.round(type / 2.8));
      let sp = 0, mi = this.rotationSeq[0], ci = 0, deleting = false;
      const step = () => {
        if (this.hasAttribute('data-paused')) { this.timers.push(setTimeout(step, 400)); return; }
        const t = this.liveText(texts[mi]);
        if (!deleting) {
          ci++;
          typed.textContent = t.slice(0, ci);
          if (ci >= t.length) { deleting = true; this.timers.push(setTimeout(step, 1600)); return; }
          this.timers.push(setTimeout(step, type));
        } else {
          ci--;
          typed.textContent = t.slice(0, ci);
          if (ci <= 0) { deleting = false; sp = (sp + 1) % this.rotationSeq.length; mi = this.rotationSeq[sp]; this.index = mi; this.updateChip(); this.pickBadge(); this.timers.push(setTimeout(step, 420)); return; }
          this.timers.push(setTimeout(step, del));
        }
      };
      step();
    }

    liveText(t) {
      if (t.indexOf('[delivered_by]') !== -1) t = t.split('[delivered_by]').join(this.deliveredByString());
      if (t.indexOf('[ready_by]') !== -1) t = t.split('[ready_by]').join(this.readyByString());
      if (t.indexOf('[miami_time]') !== -1) t = t.split('[miami_time]').join(this.timeString(0));
      return t;
    }

    /* ---------- live time tokens ---------- */
    initCountdown() {
      let hasToken = false;
      this.querySelectorAll('.ssm-bar__msg-text').forEach((el) => {
        let html = el.innerHTML;
        if (html.indexOf('[delivered_by]') !== -1) {
          html = html.split('[delivered_by]').join('<span class="ssm-cd" data-ssm-db></span>');
          hasToken = true;
        }
        if (html.indexOf('[ready_by]') !== -1) {
          html = html.split('[ready_by]').join('<span class="ssm-cd" data-ssm-rb></span>');
          hasToken = true;
        }
        if (html.indexOf('[miami_time]') !== -1) {
          html = html.split('[miami_time]').join('<span class="ssm-cd" data-ssm-mt></span>');
          hasToken = true;
        }
        el.innerHTML = html;
      });
      if (!hasToken) return;
      const update = () => {
        const db = this.deliveredByString();
        const rb = this.readyByString();
        const mt = this.timeString(0);
        this.querySelectorAll('[data-ssm-db]').forEach((el) => { el.textContent = db; });
        this.querySelectorAll('[data-ssm-rb]').forEach((el) => { el.textContent = rb; });
        this.querySelectorAll('[data-ssm-mt]').forEach((el) => { el.textContent = mt; });
      };
      update();
      this.timers.push(setInterval(update, 1000));
    }

    deliveredByString() {
      return this.timeString(parseInt(this.config.deliveryMinutes, 10) || 69);
    }

    readyByString() {
      return this.timeString(parseInt(this.config.pickupMinutes, 10) || 5);
    }

    timeString(mins) {
      const when = new Date(Date.now() + mins * 60000);
      const opts = { hour: 'numeric', minute: '2-digit' };
      try {
        if (!this._dbFmt) {
          this._dbFmt = new Intl.DateTimeFormat('en-US', Object.assign({ timeZone: this.config.timeZone || 'America/New_York' }, opts));
        }
        return this._dbFmt.format(when);
      } catch (e) {
        return new Intl.DateTimeFormat('en-US', opts).format(when);
      }
    }

    /* ---------- dismiss ---------- */
    isDismissed() {
      try {
        if (sessionStorage.getItem(this.storageKey)) return true;
        const raw = localStorage.getItem(this.storageKey);
        if (!raw) return false;
        const until = parseInt(raw, 10);
        if (until === -1) return true; // forever
        if (Date.now() < until) return true;
        localStorage.removeItem(this.storageKey);
        return false;
      } catch (e) { return false; }
    }

    dismiss() {
      try {
        const d = this.config.dismissDuration || 'session';
        if (d === 'session') sessionStorage.setItem(this.storageKey, '1');
        else if (d === '24h') localStorage.setItem(this.storageKey, String(Date.now() + 86400000));
        else if (d === '7d') localStorage.setItem(this.storageKey, String(Date.now() + 604800000));
        else localStorage.setItem(this.storageKey, '-1');
      } catch (e) { /* storage blocked: dismiss for this view only */ }
      this.classList.add('ssm-bar--hide');
      this.timers.push(setTimeout(() => { this.style.display = 'none'; }, 400));
    }
  }

  if (!customElements.get('announcement-bar-v2')) {
    customElements.define('announcement-bar-v2', AnnouncementBarV2);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      const closeButton = this.querySelector('.announcement__close');
      const ad = window.sessionStorage.getItem('announcementDismissed');

      if (!ad) {
        this.classList.remove('hide');
      }

      if (closeButton) {
        closeButton.addEventListener('click', this.hideAnnouncement.bind(this));
      }
    }

    hideAnnouncement() {
      window.sessionStorage.setItem('announcementDismissed', true);
      this.classList.add('announcement-bar--hide');

      setTimeout(() => {
        this.style.display = 'none';
      }, 300);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-signup-banner"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    class SignupBanner extends HTMLElement {
      constructor() {
        super();

        this.signupForm = this.querySelector('.newsletter-form');

        if (this.signupForm) {
          this.submitButton = this.signupForm.querySelector('button[type="submit"]');

          if (this.submitButton) {
            this.submitButton.removeAttribute('disabled');
          }

          clearInputErrors(this.signupForm);

          this.signupForm.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }

      handleSubmit(evt) {
        const formIsValid = validateForm(this.signupForm);

        if (formIsValid) {
          if (this.submitButton) {
            this.submitButton.classList.add('btn--loading');
          }
        } else {
          evt.preventDefault();
        }
      }
    }

    customElements.define('signup-banner', SignupBanner);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-linked-menu"]) return;
  try {
    
  class FaqLinkedMenu extends HTMLElement {
    constructor() {
      super();
      this.faqLinkedMenuContent = this.querySelector('.faq-linked-menu-content');
      this.accordionComponent = document.querySelectorAll('.faq-item');
      const faqlinkedItems = [];

      this.accordionComponent.forEach((elm, i) => {
        if (i != 0) {
          elm.classList.add('hide');
        }

        const faqLinkedMenuSection = elm.querySelector('[data-menu-info="faq-linked-menu"]');

        if (faqLinkedMenuSection) {
          const newMenuItem = document.createElement('li');
          newMenuItem.dataset.linkType = elm.dataset.sectionType;
          newMenuItem.innerHTML = faqLinkedMenuSection.innerHTML;

          if (i === 0) {
            newMenuItem.classList.add('active');
          }

          this.faqLinkedMenuContent.appendChild(newMenuItem);

          newMenuItem.addEventListener('click', this.handleClick.bind(this));
        }

        faqLinkedMenuSection.classList.add('hide');
      });
    }

    handleClick(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const contentId = target.dataset.linkType;

      const activeElement = document.querySelector(`[data-section-type=${contentId}]`);
      const activeHeaderItem = this.faqLinkedMenuContent.querySelector('li.active');

      if (activeHeaderItem !== target) {
        activeHeaderItem.classList.remove('active');
        target.classList.add('active');
      }

      this.accordionComponent.forEach((elm) => {
        if (!elm.classList.contains('hide')) {
          elm.classList.add('collapsible-content--hide');
          setTimeout(function () {
            elm.classList.add('hide');
          }, 200);
        }
      });

      setTimeout(function () {
        activeElement.classList.remove('hide');
        activeElement.classList.remove('collapsible-content--hide');
      }, 200);
    }
  }

  customElements.define('faq-linked-menu', FaqLinkedMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.background = this.getAttribute('data-background');
      this.applyColorScheme = this.getAttribute('data-color-scheme');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.headerSearch = this.querySelector('.header__search');

      this.headerHeight = this.header.getBoundingClientRect().height;
      this.headerWrap = this.header.querySelector('.header-wrapper');
      this.isFrosted = this.headerWrap.dataset.frosted;
      this.isSticky = this.headerWrap.dataset.sticky;
      this.menuInline = this.header.querySelector('.list-menu--inline');
      this.activeMenuItem = this.header.querySelector('.header__active-menu-item');
      this.listMenuItems = this.header.querySelectorAll('.header__inline-menu .list-menu__item-list');

      this.openingMenu = false;
      this.closingMenu = false;
      this.isFadeOutTransition = false;
      this.listMenuItems.forEach((listMenuItem) => listMenuItem.addEventListener('mouseenter', this.handleMouseEnter.bind(this)));
      this.listMenuItems.forEach((listMenuItem) => listMenuItem.addEventListener('mouseleave', this.handleMouseleave.bind(this)));
      this.listMenuItems.forEach((listMenuItem) => listMenuItem.addEventListener('click', this.handleClick.bind(this)));

      if (this.isSticky) {
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      const searchHomeField = document.getElementById('search-home-field');
      let headerHeight = this.header.getBoundingClientRect().height;
      if (searchHomeField) {
        headerHeight = headerHeight + searchHomeField.getBoundingClientRect().height;
        if (document.querySelector('.shopify-section:first-child [allow-transparent-header]')) {
          searchHomeField.classList.add('search-home--transparent');
        }
      }
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
      let prevHeight = 0;
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          if (entry.contentBoxSize) {
            const height = entry.contentBoxSize?.[0].blockSize;
            if (typeof height === 'number' && height !== prevHeight) {
              prevHeight = height;
              let headerHeight = this.header.getBoundingClientRect().height;
              if (searchHomeField) {
                headerHeight = headerHeight + searchHomeField.getBoundingClientRect().height;
              }
              document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
            }
          }
        }
      });

      resizeObserver.observe(this.header);
      this.setupTransparency();
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.setupTransparency.bind(this));
        document.addEventListener('shopify:section:unload', this.setupTransparency.bind(this));
        document.addEventListener('shopify:section:reorder', this.setupTransparency.bind(this));
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.headerSearch && this.headerSearch.isOpen()) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (!this.applyColorScheme) {
        this.header.classList.add(this.background);
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      if (!this.applyColorScheme) {
        this.header.classList.add(this.background);
      }
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

      if (!this.applyColorScheme) {
        this.header.classList.remove(this.background);
      }
    }

    handleClick(event) {
      const menuItem = event.target;
      const detailsElement = menuItem.querySelector('.details--list-menu');

      this.header.classList.add(this.background, 'is-filled');

      if (detailsElement) {
        setTimeout(() => {
          detailsElement.classList.add('sub-menu-opening');
        });
      }
    }

    handleMouseEnter(event) {
      const menuItem = event.target;
      const menuItemSpan = menuItem.querySelector('.header__menu-item');
      const detailsElement = menuItem.querySelector('.details--list-menu');
      const currentSubmenu = this.menuInline.querySelector('details[open]');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });
      menuItemSpan.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.closingMenu && detailsElement.getAttribute('open') && !this.isFadeOutTransition) {
        window.clearTimeout(this.timeoutClose);
        this.closingMenu = false;
      }

      if (detailsElement.getAttribute('open') && !this.isFadeOutTransition) return;

      window.clearTimeout(this.timeoutOpen);
      this.openingMenu = true;

      this.timeoutOpen = setTimeout(() => {
        this.openingMenu = false;
        this.openSubMenu(detailsElement);
      }, 300);
    }

    openSubMenu(detailsElement) {
      detailsElement.setAttribute('open', true);
      if (this.isFrosted) this.headerWrap.classList.remove('frosted-header-glass');
      this.header.classList.add(this.background, 'is-filled');
      this.closeMenuLocalization();
      setTimeout(() => {
        detailsElement.classList.add('sub-menu-opening');
      });
    }

    handleMouseleave(event) {
      const menuItem = event.target;
      const detailsElement = menuItem.querySelector('.details--list-menu');
      const currentSubmenu = this.menuInline.querySelector('details[open]');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });

      if (this.activeMenuItem) this.activeMenuItem.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.openingMenu && !detailsElement.getAttribute('open')) {
        window.clearTimeout(this.timeoutOpen);
        this.openingMenu = false;
      }

      if (!detailsElement.getAttribute('open')) return;

      this.closingMenu = true;
      this.timeoutClose = setTimeout(() => {
        this.closingMenu = false;
        this.closeSubMenu(detailsElement);
      }, 300);
    }

    closeSubMenu(detailsElement) {
      if (this.isFrosted) this.headerWrap.classList.add('frosted-header-glass');
      this.header.classList.remove('is-filled');
      if (!this.header.classList.contains('animate')) {
        this.header.classList.remove(this.background);
      }

      detailsElement.classList.remove('sub-menu-opening');
      this.isFadeOutTransition = true;

      detailsElement.addEventListener(
        'transitionend',
        () => {
          detailsElement.removeAttribute('open');
          this.isFadeOutTransition = false;
        },
        { once: true }
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeMenuLocalization() {
      this.headerLocalization = this.headerLocalization || this.header.querySelectorAll('localization-form');
      this.headerLocalization.forEach((disclosure) => disclosure.hidePanel());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        // this.searchModal.close(false);
      }
    }

    setupTransparency() {
      if (document.querySelector('.shopify-section:first-child [allow-transparent-header]')) {
        this.classList.add(this.background);
        this.setAttribute('data-transparency', true);
      } else {
        if (this.isSticky && !this.applyColorScheme) {
          this.classList.remove(this.background);
        }
        this.removeAttribute('data-transparency');
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  class newsletterForm extends HTMLElement {
    constructor() {
      super();
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);

      const sectionId = this.dataset.sectionId;
      const contactNewsletter = this.querySelector(`#Contact_${sectionId}`);
      const inputEmailGroup = contactNewsletter.querySelector('.input-group');
      const inputEmailNewsletter = contactNewsletter.querySelector('input[type="email"]');
      const errorMessage = contactNewsletter.querySelector(`#Newsletter-error--${sectionId}`);
      const errorMessageText = errorMessage.querySelector('.input-error-message__text');
      const iconError = contactNewsletter.querySelector('.field-wrapper__icon-error');
      const existingEmailMsg = contactNewsletter.querySelector('.newsletter-email-exist');
      const urlUserCame = document.referrer ? new URL(document.referrer) : null;

      inputEmailNewsletter.addEventListener('keyup', function (e) {
        if (e.code === 'Enter') return;
        inputEmailGroup.classList.remove('input-group--error');
        inputEmailNewsletter.classList.remove('input--error');
        errorMessage.classList.add('hide');
        iconError.classList.add('hide');
        if (existingEmailMsg) existingEmailMsg.classList.add('hide');
      });

      if (existingEmailMsg && searchParams.has('form_type') && inputEmailNewsletter.value) {
        existingEmailMsg.classList.remove('hide');
      }

      if ( urlUserCame && urlUserCame.pathname === '/challenge' ) {
        document.querySelector(`#Contact_${sectionId}`).scrollIntoView();
      }

      contactNewsletter.addEventListener('submit', (event) => {
        const email = inputEmailNewsletter.value;

        if (!this.validateEmail(email)) {
          event.preventDefault();
          var erroMessage = '';

          if (email === '') {
            erroMessage = window.loginStrings.errorEmailRequired;
          } else {
            erroMessage = window.loginStrings.errorEmailInvalid;
          }

          inputEmailGroup.classList.add('input-group--error');
          inputEmailNewsletter.classList.add('input--error');
          inputEmailNewsletter.setAttribute('aria_invalid', 'true');
          inputEmailNewsletter.setAttribute('aria_describedby', `Newsletter-error--${sectionId}`);
          inputEmailNewsletter.setAttribute('data_form_status', true);

          if (errorMessageText) errorMessageText.textContent = erroMessage;
          errorMessage.classList.remove('hide');
          iconError.classList.remove('hide');
          inputEmailNewsletter.focus();
        }

        return false;
      });
    }

    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }

  customElements.define('newsletter-form', newsletterForm);

  } catch(e) { console.error(e); }
})();
})();
